import { RootState } from "@src/store";
import { componentSlice } from "@src/store/slices/experienceBuilder/component/slice";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export function getVariationInitialDraft(state: RootState) {
  const mod = componentSlice.selectors.getInitialDraft(state);
  const variationId = experienceBuilderSlice.selectors.getVariationId(state);
  return mod?.variationId === variationId ? mod : undefined;
}
